import React from 'react';
import { ChevronDown, User, Users, Shield, UserCheck, Eye } from 'lucide-react';
import { useViewAs } from '../../context/ViewAsContext';
import { USER_ROLES } from '../../utils/constants';

const RoleSelector = ({ className = '' }) => {
  const { 
    user, 
    effectiveRole, 
    availableRoles, 
    switchToRole, 
    getRoleLabel,
    isViewingAs 
  } = useViewAs();

  if (!user || availableRoles.length === 0) {
    return null;
  }

  const getRoleIcon = (role) => {
    const iconMap = {
      [USER_ROLES.SUPER_ADMIN]: Shield,
      [USER_ROLES.EVENT_ADMIN]: Users,
      [USER_ROLES.FRONT_DESK]: UserCheck,
      [USER_ROLES.USHER]: User,
      [USER_ROLES.ATTENDEE]: Eye,
    };
    return iconMap[role] || User;
  };

  const handleRoleChange = (event) => {
    const selectedRole = event.target.value;
    if (selectedRole === user.role) {
      // Switch back to original role
      return;
    }
    switchToRole(selectedRole);
  };

  return (
    <div className={`relative ${className}`}>
    
      
      <div className="relative">
        <select
          value={effectiveRole}
          onChange={handleRoleChange}
          className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg bg-white text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 appearance-none"
        >
          {/* Current user's actual role */}
          <option value={user.role}>
            {getRoleLabel(user.role)} {!isViewingAs && '(Your Role)'}
          </option>
          
          {/* Available roles to view as */}
          {availableRoles.map((role) => (
            <option key={role} value={role}>
              {getRoleLabel(role)}
            </option>
          ))}
        </select>
        
        {/* Role icon */}
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
          {React.createElement(getRoleIcon(effectiveRole), { size: 16 })}
        </div>
        
        {/* Dropdown arrow */}
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
          <ChevronDown size={16} />
        </div>
      </div>
      
     
    </div>
  );
};

export default RoleSelector;
